import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
const NOT_THE_PLAN: string[] = ['Dar de baja todos los convenios de un día para el otro', 'Quedarte con la agenda vacía esperando pacientes particulares', 'Rechazar pacientes que hoy sostienen tu facturación'];
const THE_PLAN: string[] = ['Medir cuánto te deja realmente cada convenio por hora de sillón', 'Aumentar de a poco la proporción de pacientes particulares', 'Derivar las horas más rentables hacia las prácticas que mejor pagan', 'Reducir la dependencia de forma progresiva y controlada'];
export function CoverageSection() {
  return <section id="obras-sociales" className="bg-ivory py-12 sm:py-16" data-id="element-82" data-mp="18dl5kgbvi4r9">
      <div className="mx-auto max-w-4xl px-5" data-id="element-83" data-mp="18ap80t3xti3c">
        <div className="text-center" data-id="element-84" data-mp="2es3z17nn7chh">
          <SectionTag data-id="element-85" data-mp="2ev87wic1yweh">Obras sociales y prepagas</SectionTag>
          <h2 className="mt-4 font-display text-[1.4rem] font-bold uppercase leading-tight text-charcoal sm:text-[2rem]" data-id="element-86" data-mp="2jr6zsfwlawjn">
            No se trata de dejarlas de golpe.
            <span className="mt-1 block text-gold-deep" data-id="element-87" data-mp="r41kzf2mcgff">Se trata de depender menos.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-sans text-[0.9rem] leading-relaxed text-charcoal/70 sm:text-base" data-id="element-88" data-mp="m45oe0w93r9w">
            Las obras sociales y prepagas hoy te traen volumen, y ese volumen sostiene el
            consultorio. El objetivo no es cortar, es mejorar el mix: que la parte particular crezca
            mes a mes mientras la agenda sigue funcionando.
          </p>
        </div>

        <div className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-89" data-mp="3dnys56ptbsr">
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35
        }} className="rounded-2xl border border-stone bg-sand p-5" data-id="element-90" data-mp="3c348fkehsuw">
            <p className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial text-charcoal/50" data-id="element-91" data-mp="3lklt3gezk232">
              Esto no es el plan
            </p>
            <ul className="mt-3.5 space-y-2" data-id="element-92" data-mp="3fy1rmy41fay6">
              {NOT_THE_PLAN.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-93" data-mp="31yk2ghmtxvoa">
                  <XIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-charcoal/40" aria-hidden data-id="element-94" data-mp="320d4fjmhzrpy" />
                  <span className="font-sans text-[0.84rem] leading-snug text-charcoal/60" data-id="element-95" data-mp="36yy67nheejgi">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: 0.08
        }} className="rounded-2xl border border-gold/40 bg-gold-soft/30 p-5" data-id="element-96" data-mp="3kx4qg0tfckxp">
            <p className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-97" data-mp="m74gg8kdoye1">
              Esto sí
            </p>
            <ul className="mt-3.5 space-y-2" data-id="element-98" data-mp="vjlf36bx6jy4">
              {THE_PLAN.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-99" data-mp="rjugwhk2d1jk">
                  <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold" aria-hidden data-id="element-100" data-mp="15ag1qbt2vlk3" />
                  <span className="font-sans text-[0.84rem] font-medium leading-snug text-charcoal" data-id="element-101" data-mp="10c4vsc5wlv75">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}